import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { actionCreators } from "../redux/classCountSagas";
import GoogleChart from "../../../../components/charts/googleChart/googleChart";

const BarChart = () => {
  const dispatch = useDispatch();
  const tableView = useSelector((state) => state.classCount.selectedFilters.table_view);

  const {
    data_table: { rows = [], cols = [] },
    options
  } = useSelector((state) => state.classCount.chartData);

  return (
    <GoogleChart
      chartName="attendance_total_visits_chart"
      width="1350px"
      height={tableView ? 300 : 400}
      isTableView={tableView}
      rows={rows}
      columns={cols}
      options={options}
      enableEventListeners
      showCurrency={false}
      switchView={(data) => dispatch(actionCreators.updateTableView(data))}
    />
  );
};

export default BarChart;
